import React from 'react';

const BillFilterPanel = ({ filters, onFilterChange, onReset }) => {

    const handleChange = (field, value) => {
        onFilterChange({ ...filters, [field]: value });
    };

    return (
        <div className="filter-panel">
            <div className="filter-row">
                {/* Search */}
                <div className="filter-group" style={{ flex: 1.5 }}>
                    <label>Search</label>
                    <input
                        className="filter-control"
                        placeholder="Bill #, Customer Name, Phone..."
                        value={filters.search}
                        onChange={(e) => handleChange('search', e.target.value)}
                    />
                </div>

                {/* Date Range - From */}
                <div className="filter-group">
                    <label>From Date</label>
                    <input
                        type="date"
                        className="filter-control"
                        value={filters.dateFrom}
                        onChange={(e) => handleChange('dateFrom', e.target.value)}
                    />
                </div>

                {/* Date Range - To */}
                <div className="filter-group">
                    <label>To Date</label>
                    <input
                        type="date"
                        className="filter-control"
                        value={filters.dateTo}
                        onChange={(e) => handleChange('dateTo', e.target.value)}
                    />
                </div>

                {/* Source Filter */}
                <div className="filter-group">
                    <label>Source</label>
                    <select
                        className="filter-control"
                        value={filters.source}
                        onChange={(e) => handleChange('source', e.target.value)}
                    >
                        <option value="">All Sources</option>
                        <option value="SYSTEM">System Bills</option>
                        <option value="LEGACY">Legacy Bills</option>
                    </select>
                </div>

                {/* Status */}
                <div className="filter-group">
                    <label>Status</label>
                    <select
                        className="filter-control"
                        value={filters.status}
                        onChange={(e) => handleChange('status', e.target.value)}
                    >
                        <option value="">All Statuses</option>
                        <option value="Paid">Paid</option>
                        <option value="Pending">Pending</option>
                        <option value="Partial">Partial</option>
                        <option value="Cancelled">Cancelled</option>
                    </select>
                </div>

                {/* Payment Mode */}
                <div className="filter-group">
                    <label>Payment Mode</label>
                    <select
                        className="filter-control"
                        value={filters.paymentMode}
                        onChange={(e) => handleChange('paymentMode', e.target.value)}
                    >
                        <option value="">All Modes</option>
                        <option value="Cash">Cash</option>
                        <option value="UPI">UPI</option>
                        <option value="Card">Card</option>
                        <option value="Bank Transfer">Bank Transfer</option>
                    </select>
                </div>

                <div className="filter-group" style={{ maxWidth: '100px', display: 'flex', justifyContent: 'flex-end' }}>
                    <label>&nbsp;</label>
                    <button className="btn-secondary btn-action" onClick={onReset} style={{ height: '38px' }}>
                        Reset
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BillFilterPanel;
